import Vue from 'vue';
import NegotiationsRequestService from '../../services/mybets/negotiations-request-service';
const getDefaultState = () => {
  return {
    negotiationIds: [],
    negotiations: {
      CurrentPage: 1,
      Data: [],
      FirstPageDisplayed: 1,
      MaxNumberOfPagesDisplayed: 10,
      NumberOfPages: 0,
    },
    newNegotiation: {},
    negotiationCounters: {},
  };
};
/**
 * Vuex store - Negotiations module
 */
export const NegotiationsModule = {
  state: getDefaultState(),
  mutations: {
    /**
     *  Add new negotion
     * @param payload betslipGroup negotioations object
     */
    addNegotiation(state, payload) {
      payload.isUTC = true;
      state.negotiationIds.push(payload.BetSlipGroupID);
      state.negotiations.Data.push(payload);
      state.newNegotiation = payload;
    },
    /**
     * remove the newNegotiation from the state
     * @param {ReturnType<typeof getDefaultState>} state
     */
    clearNewNegotiation(state) {
      state.newNegotiation = {};
    },
    /**
     * remove negotioation from the store
     * @param {ReturnType<typeof getDefaultState>} state
     * @param betslipGroupId
     */
    removeNegotiation(state, betslipGroupId) {
      state.negotiationIds = state.negotiationIds.filter(m => m !== betslipGroupId);
      state.negotiations.Data = state.negotiations.Data.filter(m => m.BetSlipGroupID !== betslipGroupId);
      if (typeof state.negotiationCounters[betslipGroupId] !== 'undefined') {
        clearInterval(state.negotiationCounters[betslipGroupId].interval);
        Vue.delete(state.negotiationCounters, betslipGroupId);
      }
    },
    /**
     * initialize new counter object in the state
     * @param {ReturnType<typeof getDefaultState>} state
     * @param {number} BetSlipGroupID
     */
    addCounter(state, BetSlipGroupID) {
      state.negotiationCounters[BetSlipGroupID] = {};
    },
    /**
     * add the interval in the counter object
     * @param {ReturnType<typeof getDefaultState>} state
     * @param payload
     */
    addInterval(state, payload) {
      state.negotiationCounters[payload.BetSlipGroupID].interval = payload.interval;
    },
    /**
     * update the total time in the counter object
     * @param {ReturnType<typeof getDefaultState>} state
     * @param payload
     */
    updateTotal(state, payload) {
      state.negotiationCounters[payload.BetSlipGroupID].total = payload.total;
      state.negotiationCounters = Object.assign({}, state.negotiationCounters);
    },
    /**
     * Clear all negotiation data, used on player login/logut
     * @param {ReturnType<typeof getDefaultState>} state
     */
    resetNegotiations(state) {
      // First when we have any intervals clear them to avoid memory leaks
      Object.values(state.negotiationCounters).forEach(nc => {
        if (nc.interval) {
          clearInterval(nc.interval);
        }
      });
      // Then reset the state to inital state
      Object.assign(state, getDefaultState());
    }
  },
  actions: {
    /**
     * start counter for negotiation
     * @param  betslipGroup
     */
    startCounter({ commit, dispatch }, betslipGroup) {
      commit('addCounter', betslipGroup.BetSlipGroupID);
      const interval = setInterval(() => {
        const total = new Date(betslipGroup.TimeOut) - Date.now();
        commit('updateTotal', {
          BetSlipGroupID: betslipGroup.BetSlipGroupID,
          total,
        });
        if (total <= 0) {
          dispatch('processOffer', { isAccepted: false, betSlipGroupID: betslipGroup.BetSlipGroupID });
        }
      }, 1000);
      commit('addInterval', { BetSlipGroupID: betslipGroup.BetSlipGroupID, interval });
    },
    processOffer({ commit }, payload) {
      const negotiationsService = new NegotiationsRequestService();
      negotiationsService.postParams.betSlipGroupID = payload.betSlipGroupID;
      negotiationsService.postParams.isAccepted = payload.isAccepted;
      negotiationsService.execute(() => {
        commit('removeNegotiation', payload.betSlipGroupID);
      });
    },
  },
  getters: {
    /**
     * Get cout of negotiations 
     * @param {ReturnType<typeof getDefaultState>} state
     */
    negotiationsCount(state) {
      return state.negotiationIds.length;
    },
  },
};
